import { render, staticRenderFns } from "./ContextTextHeader.vue?vue&type=template&id=49ec51ba&scoped=true&"
import script from "./ContextTextHeader.vue?vue&type=script&lang=js&"
export * from "./ContextTextHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContextTextHeader.vue?vue&type=style&index=0&id=49ec51ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ec51ba",
  null
  
)

export default component.exports